module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAbklEQVRIiWMYBUMT/M+zEfifZxNAjOOZyPShAwMDw/r/eTYJNAshkOH/82z+j1oy+C1hRFPUQKE9/gwMDAYMDAyJjJOOLGCgIJnSH9A0skcNHxDDA4g1nIVMOw4wMDAEMk46soFM/aOAXoCBgQEAj35Yuo9SDigAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_btn_arrow2.png
// module id = 303
// module chunks = 0